import { useFeatureValue } from '@shared/core/featureFlags';

export const LOCAL_STORAGE_SLAP_AD_TRAVEL = 'travel__slapAdClosed';

export const useSlapAdsTravelExperiment = () => {
  const { value: slapAdTravelExperiment } = useFeatureValue('roomBlockSlapAdsExperiment');
  const slapAdClosed = localStorage.getItem(LOCAL_STORAGE_SLAP_AD_TRAVEL);
  return slapAdTravelExperiment === 'on' && !slapAdClosed;
};
